
 



 
 import {fs} from "Config/FsConfig";
 
    import ConfigurationSearchParameter from 'Modules/Core/Scripts/AppServiceContract/ConfigurationSearchParameter';

    import ConfigurationData from 'Modules/Core/Scripts/AppServiceContract/ConfigurationData';

    import ConfigurationItemCategoryData from 'Modules/Core/Scripts/AppServiceContract/ConfigurationItemCategoryData';

    import ConfigurationItemCategorySearchCriteria from 'Modules/Core/Scripts/AppServiceContract/ConfigurationItemCategorySearchCriteria';

    import ConfigurationRequest from 'Modules/Core/Scripts/AppServiceContract/ConfigurationRequest';


    //module ConfigurationAppService {
    class ConfigurationAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Core.AppService/ConfigurationAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Core.AppService/ConfigurationAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFind = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ConfigurationAppService/Find`;
    public RouteFind() : string {
        return this.ControllerUrl + "/"+"Find";
    }
    public Find(configurationSearchParameter: ConfigurationSearchParameter): JQuery.jqXHR<ConfigurationData[]> {
        return $.ajax({
                url: this.RouteFind(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(configurationSearchParameter),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindCategoryData = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ConfigurationAppService/FindCategoryData`;
    public RouteFindCategoryData() : string {
        return this.ControllerUrl + "/"+"FindCategoryData";
    }
    public FindCategoryData(): JQuery.jqXHR<ConfigurationItemCategoryData[]> {
        return $.ajax({
                url: this.RouteFindCategoryData(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteCount = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ConfigurationAppService/Count`;
    public RouteCount() : string {
        return this.ControllerUrl + "/"+"Count";
    }
    public Count(searchCriteria: ConfigurationItemCategorySearchCriteria): JQuery.jqXHR<number> {
        return $.ajax({
                url: this.RouteCount(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(searchCriteria),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteUpdate = () => this.ServiceUrl + `modules/Fs.Erp.Core.AppServiceContract/ConfigurationAppService/Update`;
    public RouteUpdate() : string {
        return this.ControllerUrl + "/"+"Update";
    }
    public Update(configurationItemCategoryRequest: ConfigurationRequest): JQuery.jqXHR<void> {
        return $.ajax({
                url: this.RouteUpdate(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(configurationItemCategoryRequest),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default ConfigurationAppService;



